import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isRumExcludedPath } from './privacyConfig';
/**
 * Keeps Session Replay off while an excluded route is on screen. The page content itself is hidden from
 * the recorder by the shared Outlet; this covers what renders outside it (dialogs, menus, toasts).
 */
export var useRumRouteGuard = function () {
    var pathname = useLocation().pathname;
    var isExcluded = isRumExcludedPath(pathname);
    useEffect(function () {
        if (isExcluded) {
            datadogRum.stopSessionReplayRecording();
        }
        else {
            // No-op while already recording, and still subject to the replay sample rate.
            datadogRum.startSessionReplayRecording();
        }
    }, [isExcluded]);
};
